import Container from '@mui/material/Container';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { projectApis } from '../../../apis/projectApis';
import ProjectForm from '../../../components/page-sections/project-form/ProjectForm';
import Breadcrumbs from '../../../components/sections/breadcrumbs/Breadcrumbs';
import TitlePanel from '../../../components/sections/title-panel/TitlePanel';
import { useUser } from '../../../contexts/UserContext';
import useToast, { TOAST_TYPE } from '../../../hooks/useToast';
import { buildPath, PRIVATE_ROUTE } from '../../../routes/routes';
import { mapBlobFormData } from '../../../utils/utils';

const NewProjectPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { showToast } = useToast();
  const { refreshUser } = useUser();

  const handleSubmit = async (data) => {
    const formData = mapBlobFormData(data, 'project');
    try {
      const formResponse = await projectApis.createProject(formData);

      // Refresh the user with the new project role data.
      await refreshUser();

      const message = t('createSuccessWithName', {
        ns: 'notifications',
        text: t('project', { ns: 'project' }),
        name: formResponse.data.name,
      });
      showToast(TOAST_TYPE.SUCCESS, message);

      const projectOverview = buildPath({
        path: PRIVATE_ROUTE.PROJECT_OVERVIEW,
        params: { projectId: formResponse.data.id },
      });
      navigate(projectOverview);
    } catch (error) {
      const message = t('submit', {
        ns: 'submit',
        content: t('project', { ns: 'project' }),
      });
      showToast(TOAST_TYPE.ERROR, message);
    }
  };

  return (
    <Container>
      <Breadcrumbs />
      <TitlePanel title={t('newProject', { ns: 'sectionTitles' })} />
      <ProjectForm onSubmit={handleSubmit} />
    </Container>
  );
};

export default NewProjectPage;
